<!-- mat icon "open in full" -->

<svg
  xmlns="http://www.w3.org/2000/svg"
  enable-background="new 0 0 24 24"
  height="24px"
  viewBox="0 0 24 24"
  width="24px"
  fill="currentColor"
>
  <rect fill="none" height="24" width="24" />
  <polygon
    points="11,3 3,3 3,11 6.29,7.71 16.29,17.71 13,21 21,21 21,13 17.71,16.29 7.71,6.29"
  />
</svg>
